var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResources = function SvgResources(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.714 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.714 11.429 22.857 0 0 11.429l22.857 11.428zM22.857 3.793l15.272 7.636-15.272 7.635-15.27-7.635zm18.279 13.918L45.714 20 22.857 31.429 0 20l4.578-2.289 18.279 9.139zm0 8.571 4.578 2.289L22.857 40 0 28.571l4.578-2.289 18.279 9.139z"
  })));
};
export default SvgResources;